import { render, staticRenderFns } from "./dictType.vue?vue&type=template&id=9b0c8908&scoped=true&"
import script from "./dictType.vue?vue&type=script&lang=ts&"
export * from "./dictType.vue?vue&type=script&lang=ts&"
import style0 from "./dictType.vue?vue&type=style&index=0&id=9b0c8908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0c8908",
  null
  
)

export default component.exports